import ENV_VARS from '@/config'
import { post, del, put } from '@/ports/api'

const { BACKEND_SERVER } = ENV_VARS

export const getStandaloneTrustScoreList = post(`${BACKEND_SERVER}/trust_score/standalone/search`, {
  noLoading: true,
  failSilently: true
})

export const getStandaloneTrustScoreFavourite = put(
  `${BACKEND_SERVER}/trust_score/standalone/%id%/favourite`,
  {
    noLoading: true
  }
)

export const deleteTrustScoreDraft = del(`${BACKEND_SERVER}/trust_score/standalone/%id%`, {
  noLoading: true
})
